import { globalStyle, style } from '@vanilla-extract/css';

export const text = style({});

globalStyle(`${text}:not(:empty), ${text} span:not(:empty)`, {
  fontSize: 'var(--font-size, inherit)',
  lineHeight: 'var(--line-height, inherit)',
  verticalAlign: 'var(--vertical-align, baseline)',

  '@media': {
    'only screen and (--mobile)': {
      fontSize: 'var(--mobile-font-size, inherit)',
      lineHeight: 'var(--mobile-line-height, inherit)',
      verticalAlign: 'var(--mobile-vertical-align, var(--vertical-align, baseline))',
    },
  },
});

globalStyle(`${text}:empty::after ,${text} span:empty::after`, {
  content: '\\FEFF' /* to keep height of the element constant */,
});
